import { SrOrderStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import type React from 'react';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { Badge } from '../../list-views/components/badge.tsx';

type Props = {
    status: SrOrderStatus;
    type: SrSalesOrderType;
    className?: string;
};

export const OrderStatusBadge: React.FC<Props> = ({ status, type, className }) => {
    const { t } = useLocale('order-status');
    const color = getOrderStatusColor(type, status);

    return (
        <Badge color={color} className={className}>
            {t(status)}
        </Badge>
    );
};

type StatusColor = 'yellow' | 'orange' | 'green' | 'red' | 'blue' | 'neutral';

function getOrderStatusColor(type: SrSalesOrderType, status: SrOrderStatus): StatusColor {
    if (type === SrSalesOrderType.QUOTE) {
        switch (status) {
            case SrOrderStatus.LOST:
                return 'red';
            case SrOrderStatus.OPEN:
                return 'yellow';
            case SrOrderStatus.PARTIALLY_RECEIVED:
                return 'blue';
            case SrOrderStatus.RECEIVED:
                return 'green';
            default:
                return 'neutral';
        }
    }
    switch (status) {
        case SrOrderStatus.BILLED:
        case SrOrderStatus.PROCESSED_INTERNALLY:
            return 'green';
        case SrOrderStatus.CANCELLED:
            return 'red';
        case SrOrderStatus.OPEN:
            return 'yellow';
        case SrOrderStatus.OPEN_IN_PICKING:
        case SrOrderStatus.PARTIALLY_PICKED:
        case SrOrderStatus.PICKED:
            return 'orange';
        case SrOrderStatus.PARTIALLY_BILLED:
            return 'blue';
        default:
            return 'neutral';
    }
}
